export default class MUMErrors {

  /**
   * Create a new MUMErrors instance
   */
  constructor() {
    this.errors = {}
  }

  /**
   * Determine if an error exists for the given field
   */
  has(field) {
    return this.errors.hasOwnProperty(field)
  }

  /**
   * Determine if we have any errors
   */
  any(){
    return Object.keys(this.errors).length > 0
  }

  /**
   * Gets the error messages for form fields
   */
  get(field) {
    if (this.errors[field]) {
      return _.isArray(this.errors[field])
        ? this.errors[field][0]
        : this.errors[field]
    }
  }

  /**
   * Sets the error messages for form fields
   */
  set(errors){
    if(errors.errors) {
      this.errors = errors.errors
    }

    this.errors.message = errors.message
  }

  /**
   * Clear one or all error fields
   *
   * @param {string|null} field
   */
  clear(field = null){
    if (field) {
      delete this.errors[field]

      return
    }

    this.errors = {}
  }
}